/**
 * Reusable metric badge — green/yellow/red based on capacity ratio.
 * Used on detail page + history list.
 */
import React from 'react';

export function CapacityBadge({ value, capacity, label, suffix = '' }) {
  let color = 'neutral';
  if (capacity > 0) {
    const ratio = value / capacity;
    if (ratio > 1) color = 'red';
    else if (ratio >= 0.9) color = 'amber';
  }
  return (
    <span className={`audit-metric-badge ${color}`}>
      {label}: <strong>{value}{suffix}</strong>
      {capacity > 0 && <small> / {capacity}</small>}
    </span>
  );
}

export function StatusBadge({ status }) {
  const map = {
    generating: { label: 'Generating…', cls: 'amber' },
    ready: { label: 'Ready', cls: 'green' },
    failed: { label: 'Failed', cls: 'red' },
  };
  const m = map[status] || { label: status, cls: 'neutral' };
  return <span className={`audit-status-badge ${m.cls}`}>{m.label}</span>;
}
